export default "__VITE_ASSET__Do2pJYhG__"